<script>
	export let item;
	$: label = item.name;
	
	function showhex() {
		label = item.hex;
	}
	function showname() {
		label = item.name;
	}
	function copyhex() {
		label = "copied";
	
	navigator.clipboard.writeText(item.hex).then(() => {
		console.log(item.hex);
	},() => {
		console.error('Failed to copy');
	})
};
</script>

<div class='ListItem' 
	style="background-color:{item.hex}; color:{item.bestContrast}"
	on:pointerover={showhex}
	on:pointerout={showname}
	on:pointerdown={copyhex}>
	{label}
</div>

<style>
	.ListItem {
		width: 100%;
		display: flex;
		position: relative;
		font-family: 'Mikron';
		font-size: 20px;
		line-height: 16px;
		letter-spacing: 2px;
		text-rendering: optimizeSpeed;
		white-space: nowrap;
		-webkit-font-smoothing: antialiassed;
		-moz-osx-font-smoothing: grayscale;
		flex-grow: 1;
		flex-shrink: 1;
		padding: 0px 24px;
		align-items: center;
		cursor: pointer;
		min-height: 3rem; /* without this is unstable */
		overflow: hidden;
	}
</style>